<script>
  export default {
    setup() {
      let cards = {
        red: {
          name: 'Красный',
          description: 'Эффективна деятельность, требующая от человека защиты личных границ, активности и выносливости, отстаивания своей точки зрения, конкурентного взаимодействия.',
        },
        blue: {
          name: 'Синий',
          description: 'Эффективна деятельность, требующая от человека проверки ошибок, «разбора полетов», рефлексии, концентрации, детального анализа.',
        },
        green: {
          name: 'Зеленый',
          description: 'Эффективна деятельность, требующая от человека внимательного слушания, самоанализа, достижения соглашения, обучения новым навыкам и умениям.',
        },
        yellow: {
          name: 'Желтый',
          description: 'Эффективна деятельность, требующая от человека мотивационной деятельности, социального взаимодействия, творчества, вовлечения других людей в свои идеи и проекты.',
        },
      }

      return {
        cards
      }
    }
  }
</script>

<template>
  <div class="additional_instruction">
    <div class="instruction_header">
      <h2>Инструкция</h2>
    </div>
  </div>
  <div class="main_text_wrapper">
    <p>
      Навигатор эмоций поможет вам улучшить эффективность своей деятельности, подсказывая, как соотносить ваши задачи и эмоции и
      применять их ресурс.
    </p>
    <p>
      Как же определить, при таком разнообразии эмоций и их оттенков, какую именно эмоцию вы сейчас испытываете? Для этого
      психологи создали специальную систему координат, где эмоции измеряют по двум параметрам — ощущение (от неприятных к
      приятным) и энергия (от низкой до высокой). Визуально это можно изобразить вот так:
    </p>
    <div>
      <img alt="Схема" src="@/assets/images/mood_tracker/tracker_schema.png" class="schema">
    </div>
    <p>
      Ощущение — это то, насколько вам сейчас приятно или неприятно, по шкале от 0 до 10. Энергия — это уровень физической энергии,
      которую вы ощущаете, также по шкале от 0 до 10.
    </p>
    <p>
      Исследования психологов показали, что большинство эмоций ситуационно-эффективны — они помогают в той или иной
      деятельности, усиливая ее, если присутствуют во время ее исполнения.
    </p>
    <p>
      Эмоции можно разложить на четыре квадрата, в которых эффективна та или иная деятельность: высокая энергия и неприятные
      ощущения (красный квадрат), высокая энергия и приятные ощущения (желтый квадрат), низкая энергия и неприятные ощущения
      (синий квадрат), низкая энергия и приятные ощущения (зеленый квадрат).
    </p>

    <div>
      <div v-for="([key, value]) in Object.entries(cards)" :key="key" class="square_wrapper" :class="key">
        <div class="square" :class="key">
          <p>
            {{ value.name }} <br/> Квадрат
          </p>
        </div>
        <div class="square_description" :class="key">
          {{ value.description }}
        </div>
      </div>
    </div>
    <p>
      Так можно понять, полезна ли эмоция, которую вы сейчас испытываете, для того, что вы делаете или собираетесь делать –
      «помогает ли мне эта эмоция в моей деятельности в данный момент?», и если она не эффективна, изменить ее или научиться
      проживать без вреда для себя и окружающих.
    </p>
    <p>
      Попробуйте сейчас оценить ваш уровень энергии и ваши ощущения. В каком квадрате вы находитесь сейчас?
    </p>
    <div>
      <ul class="steps_list">
        <li class="instruction_step">
          <div class="step_header">
            1. Нажмите на карточку
          </div>
          <ul class="small_list">
            <li>
              Нажмите на карточку → после переворота вы найдете на ней краткое описание данного квадрата. Если описание соответствует вашему эмоциональному состоянию сейчас, то смело нажимайте кнопку “Это мое состояние сейчас“ и переходите к пункту 3. Если хотите узнать больше, нажмите на кнопку “Узнать подробнее про состояние“.
            </li>
            <li>
              Откроется окно с подробным описанием и вопросом в конце: Это похоже на то, что вы чувствуете сейчас?
            </li>
            <li>
              Выберите: “Да” / ”Нет” / “Не знаю”
            </li>
          </ul>
        </li>

        <li class="instruction_step">
          <div class="step_header">
            2. Если не знаете, в каком вы квадрате
          </div>
          <ul class="small_list">
            <li>
              Нажмите “Не знаю“.
            </li>
            <li>
              Ответьте на вопрос: “Чтобы точнее определить, в каком состоянии вы находитесь, выберите, какое из утверждений Вам сейчас ближе?”, выбрав наиболее подходящее утверждение из списка.
            </li>
            <li>
              Система определит ваш квадрат.
            </li>
            <li>
              Подтвердите предложенный результат.
            </li>
            <li>
              Если сомневаетесь в правильности предложенного системой квадрата, нажмите “Не уверен“ и следуйте подсказкам.
            </li>
          </ul>
        </li>

        <li class="instruction_step">
          <div class="step_header">
            3. Выберите задачу
          </div>
        </li>

        <li class="instruction_step">
          <div class="step_header">
            4. Получите подсказку
          </div>
          <ul class="small_list">
            <li>
              Если состояние помогает — получите поддерживающую рекомендацию и отметьте время для оценки результата и подведения итогов.
            </li>
            <li>
              Если мешает — получите рекомендацию, как адаптировать свое состояние (настроиться, переключиться, изменить подход) или изменить задачу.
            </li>
          </ul>

        </li>

        <li class="instruction_step">
          <div class="step_header">
            5. Сохраните результат
          </div>
          <p>
            Использование этого инструмента регулярно развивает <b>гибкость, саморегуляцию и стратегическое мышление</b> в работе с эмоциями.
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped lang="scss">

.additional_instruction {
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}

.instruction_header {
  max-width: fit-content;
  padding: 0 40px;
  border-bottom: 1px solid #cccccc;
  font-size: 30px;
  font-weight: bold;
  text-transform: uppercase;
}

.main_text_wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  text-align: justify;
}

.square_wrapper {
  display: flex;
  align-items: center;
  column-gap: 15px;
  margin-bottom: 10px;
}

.square {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  width: 90px;
  height: 90px;
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
  text-align: center;
}

.square.blue {
  background-color: var(--tracker-color-blue);
}

.square.red {
  background-color: var(--tracker-color-red);
}

.square.green {
  background-color: var(--tracker-color-green);
}

.square.yellow {
  background-color: var(--tracker-color-yellow);
}

.square_description {
  width: 88%;
  padding: 20px;
  border: 1px solid #cccccc;
}

.square_description.blue {
  border-color: var(--tracker-color-blue);
}

.square_description.red {
  border-color: var(--tracker-color-red);
}

.square_description.green {
  border-color: var(--tracker-color-green);
}

.square_description.yellow {
  border-color: var(--tracker-color-yellow);
}

.instruction_step:not(:last-child) {
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid #cccccc;
}

.instruction_step h3 {
  font-weight: bold;
}

.step_header {
  margin-bottom: 15px;
  font-size: 18px;
  font-weight: bold;
}

.small_list, .small_list li {
  list-style: initial;
}

.small_list {
  padding-left: 20px;
}

.schema {
  height: 350px;
}

@media (max-width: 1000px) {
  .schema {
    height: 200px;
  }
}

@media (max-width: 760px) {
  .schema {
    height: 150px;
  }
}

</style>